import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root";

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign_in",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "OnboardingSignInPage" */ "@circle-react/components/OnboardingPage/SignInPage"
      ),
    "SignInPage",
  ),
});
